import { Box, Typography } from '@mui/material';
import { sharedStyles } from '../../utils/Style';

type TextColumnProps = {
  value: string;
  secondary?: string;
};

export const TextColumn = ({ value, secondary }: TextColumnProps) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography sx={sharedStyles.tableStringField}>{value}</Typography>
      {!!secondary && (
        <Typography sx={sharedStyles.tableSecondaryField}>
          {secondary}
        </Typography>
      )}
    </Box>
  );
};
